export const toastTypes: {
  error: 'error';
  success: 'success';
} = {
  error: 'error',
  success: 'success',
};

export type ToastType = keyof typeof toastTypes;
